module.exports = __webpack_public_path__ + "media/images/responsive/fairs/cv/scroll_arrow-0fed6dc44ad50aea718a4ca38d47b189.png";